import styled from 'styled-components';
import { IFilterInputType } from '../../../../types/ProfileTypes';
import { Col } from 'react-flexbox-grid';

export const FilterLabel = styled.div`
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: left;
  margin-top: 5px;
  line-height: 30px;
`;

interface IFieldContent {
  type?: IFilterInputType;
  padding?: string;
  margin?: string;
}
export const FieldContent = styled.div`
  display: flex;
  flex-direction: ${(props: IFieldContent) => (props?.type === 'BOOLEAN' ? 'row' : 'column')};
  width: ${(props: IFieldContent) => props?.type === 'BOOLEAN' && 'calc(50% - 8px)'};
  justify-content: center;
  align-items: start;

  & .gsi-filter-field {
    margin-top: ${(props: IFieldContent) => props?.type === 'BOOLEAN' && '5px'};
    width: ${(props: IFieldContent) => props?.type === 'BOOLEAN' && '90px!important'};
    & .bp3-button-text {
      position: ${(props: IFieldContent) => props?.type === 'BOOLEAN' && 'absolute'};
      left: ${(props: IFieldContent) => props?.type === 'BOOLEAN' && '80px'};
      width: ${(props: IFieldContent) => props?.type === 'BOOLEAN' && '160px'};
    }
  }
`;

export const ColStyled = styled(Col)`
  margin-top: ${(props: IFieldContent) => props?.type === 'BOOLEAN' && '5px'};
  margin-bottom: 5px;
  ${(props: IFieldContent) => (props.padding ? `padding: ${props.padding}!important;` : '')}
  ${(props: IFieldContent) => (props.margin ? `margin: ${props.margin}!important;` : '')}
`;
